var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPrevMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.707 9.29303C16.8945 9.48056 16.9998 9.73487 16.9998 10C16.9998 10.2652 16.8945 10.5195 16.707 10.707L13.414 14L16.707 17.293C16.8892 17.4816 16.99 17.7342 16.9877 17.9964C16.9854 18.2586 16.8803 18.5094 16.6948 18.6948C16.5094 18.8803 16.2586 18.9854 15.9964 18.9877C15.7342 18.99 15.4816 18.8892 15.293 18.707L11.293 14.707C11.1056 14.5195 11.0002 14.2652 11.0002 14C11.0002 13.7349 11.1056 13.4806 11.293 13.293L15.293 9.29303C15.4806 9.10556 15.7349 9.00024 16 9.00024C16.2652 9.00024 16.5195 9.10556 16.707 9.29303Z",
    fill: "#374151"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPrevMonth);
export default __webpack_public_path__ + "static/media/calendar-prev-month.624258f642a7575beb1a5626ea7427f9.svg";
export { ForwardRef as ReactComponent };